import axios from 'axios';
import { responseOnAxiosResponse, responseOnReject } from './interceptor';
import { store } from '@stb/redux';

const graphqlVolta = axios.create({
  baseURL: process.env.REACT_APP_/dev/stb/web_NODE_VOLTA + '/graphql',
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
  method: 'POST',
});

graphqlVolta.interceptors.request.use(
  (config) => {
    const authData = store.getState().auth;
    if (authData.action === 'LOG_IN') {
      config.headers['Authorization'] = `Bearer ${authData.session.user.access_token}`;
    }

    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

graphqlVolta.interceptors.response.use(responseOnAxiosResponse, responseOnReject);

export default graphqlVolta;
